import i18n from './index';

export const commerceCopy = {
  'Lavoro quotidiano': ['Daily work', 'Tagesgeschäft', 'Travail quotidien', 'Trabajo diario'],
  'Vendite e crescita': ['Sales and growth', 'Verkauf und Wachstum', 'Ventes et croissance', 'Ventas y crecimiento'],
  'Organizzazione': ['Organization', 'Organisation', 'Organisation', 'Organización'],
  'Impostazioni e account': ['Settings and account', 'Einstellungen und Konto', 'Paramètres et compte', 'Configuración y cuenta'],
  'Magazzino & Vendite': ['Inventory & Sales', 'Lager & Verkauf', 'Stock & Ventes', 'Inventario y ventas'],
  'Sezioni Magazzino & Vendite': ['Inventory & Sales sections', 'Bereiche Lager & Verkauf', 'Sections Stock & Ventes', 'Secciones de inventario y ventas'],
  'Magazzini': ['Inventory', 'Lager', 'Stocks', 'Inventarios'],
  'Supply': ['Supply', 'Supply', 'Supply', 'Supply'],
  'Shop': ['Shop', 'Shop', 'Shop', 'Shop'],
  'Acquisti e fornitori': ['Purchases and suppliers', 'Einkauf und Lieferanten', 'Achats et fournisseurs', 'Compras y proveedores'],
};
for (const [index, language] of ['en', 'de', 'fr', 'es'].entries()) {
  i18n.addResources(language, 'commerce', Object.fromEntries(
    Object.entries(commerceCopy).map(([source, translations]) => [source, translations[index]])
  ));
}
export function commerceText(source) {
  return i18n.t(source, {ns: ['commerce', 'copy'], keySeparator: false, nsSeparator: false, defaultValue: source});
}
